module.exports = __webpack_public_path__ + "img/01.f4239025.png";